import React, { useCallback, useEffect } from "react";
import { Button, Form, Input, message, Row, Spin } from "antd";
import { editConfig, loadConfig } from "../../../application/config-slice";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import I18n from "../../i18n";

const { Item } = Form;

export default function Settings() {
  const dispatch = useAppDispatch();
  const { loading, editLoading, config } = useAppSelector(
    (state) => state.config
  );
  const [form] = Form.useForm();

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadConfig());
  }, [stableDispatch]);

  useEffect(() => {
    if (editLoading === "succeeded") {
      stableDispatch(loadConfig());
      message.success(I18n.config.editedSuccesfully);
    } else if (editLoading === "failed") {
      message.error(I18n.general.networkError);
    }
  }, [editLoading, stableDispatch]);

  const stableSetFields = useCallback(form.setFields, []);
  useEffect(() => {
    if (loading === "succeeded") {
      stableSetFields([
        { name: "deliveryPrice", value: config?.deliveryPrice },
        { name: "freeDeliveryMinPrice", value: config?.freeDeliveryMinPrice },
        { name: "pageSize", value: config?.pageSize },
      ]);
    }
  }, [stableSetFields, loading, config]);

  const edit = () => {
    dispatch(
      editConfig(
        form.getFieldValue("deliveryPrice"),
        form.getFieldValue("freeDeliveryMinPrice"),
        form.getFieldValue("pageSize")
      )
    );
  };

  const isEditLoading = editLoading === "pending";
  if (loading !== "succeeded")
    return (
      <Row
        justify="center"
        align="middle"
        style={{ width: "100%", height: 300 }}
      >
        <Spin spinning={loading === "pending"} />
      </Row>
    );
  return (
    <div style={{ width: 300, margin: "16px 24px" }}>
      <Form form={form} layout="vertical">
        <Item name="pageSize" label={I18n.config.pageSize}>
          <Input
            name="pageSize"
            defaultValue={config?.pageSize}
            inputMode="numeric"
            disabled={isEditLoading}
          />
        </Item>
        <Item name="deliveryPrice" label={I18n.config.deliveryPrice}>
          <Input
            name="deliveryPrice"
            defaultValue={config?.deliveryPrice}
            inputMode="numeric"
            disabled={isEditLoading}
          />
        </Item>
        <Item
          name="freeDeliveryMinPrice"
          label={I18n.config.freeDeliveryMinPrice}
        >
          <Input
            name="freeDeliveryMinPrice"
            defaultValue={config?.freeDeliveryMinPrice}
            inputMode="numeric"
            disabled={isEditLoading}
          />
        </Item>
        <Item>
          <Button type="primary" block onClick={edit} loading={isEditLoading}>
            {I18n.general.edit}
          </Button>
        </Item>
      </Form>
    </div>
  );
}
